// PanelAttributesDialog.tsx — Quantity, finish, sealer, notes

import { useState } from 'react';
import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';
import type { MpVar } from '../types/panelvar';

export default function PanelAttributesDialog() {
  const { ui, project, updateMpVar } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updateMpVar: s.updateMpVar,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [mp, setMp] = useState<Partial<MpVar>>(panel?.mpvar ?? {});
  if (!panel) return null;

  function set<K extends keyof MpVar>(key: K, value: MpVar[K]) {
    setMp(prev => ({ ...prev, [key]: value }));
  }

  return (
    <DialogBase title="Panel Attributes" onOk={() => updateMpVar(panel.id, mp)}>
      <div className="dialog-row">
        <label className="dialog-label">Quantity</label>
        <input
          className="dialog-input sm"
          type="number"
          value={mp.quantity ?? 1}
          min={1}
          step={1}
          onChange={e => set('quantity', parseInt(e.target.value))}
        />
        <span className="dialog-unit">pcs</span>
      </div>
      {(['finish', 'color', 'sealer', 'notes'] as (keyof MpVar)[]).map(key => (
        <div className="dialog-row" key={key as string}>
          <label className="dialog-label">{String(key).charAt(0).toUpperCase() + String(key).slice(1)}</label>
          <input
            className="dialog-input"
            type="text"
            value={(mp[key] as string) ?? ''}
            onChange={e => set(key, e.target.value as MpVar[typeof key])}
          />
        </div>
      ))}
    </DialogBase>
  );
}
